class Header {
  constructor() {
    this.event();
  }
  event() {
    // ハンバーガーメニューのクリックイベント
    $(".hamburger-btn").click(function () {
      $(".l-header").toggleClass("is-active");
      $("body").toggleClass("is-fixed");
    });

    // トップページ判定とクラス付与
    function setHeaderTopClass() {
      if ($('.p_top').length > 0) {
        $(".l-header").addClass("p-top");
      } else {
        $(".l-header").removeClass("p-top");
      }
    }

    // DOM読み込み後に実行
    $(document).ready(function() {
      setHeaderTopClass();
    });

    // スクロールイベント
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 50) {
        $(".l-header").addClass("scroll-active");
      } else {
        $(".l-header").removeClass("scroll-active");
      }
    });
  }
}

